import { createAction } from 'vizzuality-redux-tools';

export const setBasemap = createAction('MAP/SET_BASEMAP');
export const setLocation = createAction('MAP/SET_LOCATION');
export const resetLocation = createAction('MAP/RESET_LOCATION');
export const setPopUp = createAction('MAP/SET_POP_UP');
